import React, { useState, useEffect } from 'react';
import './Manage.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Paper , Grid , Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Invoice from './Invoice'; // Adjust path if necessary
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios, { decryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import { buttonBackgroundColor } from '../common';

const Container = ({ batchDetails }) => {
  const [openModal, setOpenModal] = useState(false);
  const [intakedata, setIntakedata] = useState([]);
  const [batches, setBatches] = useState();
  const { intakeId } = useParams();
  const intakeId1 = decryptData(decodeURIComponent(intakeId));


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/intake-details/intakeId/${intakeId1}`);
        if (response.data) {
          console.log('API Response:', response.data);
          setIntakedata(response.data);

        } else {
          throw new Error('Data format is incorrect');
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };
    fetchData();
  }, [intakeId1]);


  useEffect(() => {
    console.log("batchDetails", batchDetails)
    const fetchBatches = async () => {
      try {
        const response = await axios.get("batch-summary"); // API endpoint to get batches
        const filteredBatches = response.data.filter(
          (batch) => batch.id === batchDetails.id
        );
        setBatches(filteredBatches[0]);
        console.log("hh", batchDetails)
        // setBatches(response.data);
      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    };
    fetchBatches();
  }, []);



  if (!batchDetails) {
    return <p>Loading...</p>;
  }

  const moduleDetailsMap = {};
  batchDetails?.moduleDetails.forEach((module) => {
    moduleDetailsMap[module.id] = module.moduleName;
  });

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Extract days from intakeDetailsDays
  const intakeDays = intakedata.intakeDetailsDays || [];
  const start = intakedata.scheduleDateDetails ? intakedata.scheduleDateDetails[0] : null;
  const end = intakedata.scheduleDateDetails && intakedata.scheduleDateDetails.length > 5 ? intakedata.scheduleDateDetails[5] : null;
  const formatDate = (date) => {
    if (date) {
      const formattedDate = new Date(date);
      const day = String(formattedDate.getDate()).padStart(2, '0'); // Ensure day is 2 digits
      const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // Ensure month is 2 digits
      const year = formattedDate.getFullYear();

      return `${day}-${month}-${year}`; // Format as day-month-year
    }
    return 'N/A';
  };

  return (
    <Box
  sx={{
    width: '100%',
    maxWidth: '1400px',
    margin: 'auto',
    padding: 3,
  }}
>
  <Paper
     sx={{
      width: '100%',
      padding: 3,
      borderRadius: 3,
      backgroundColor: '#f9f9f9', // light gray background
      boxShadow: 3,
    }}
  >
        <Grid container spacing={2}>
          {/* Left Section */}
          <Grid item xs={12} md={6}>
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography variant="subtitle1">
                <strong>Course</strong>: {batchDetails.batchcode}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Venue</strong>: {batchDetails.venue}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Batch No</strong>: {intakedata.intakeId}
              </Typography>
            </Box>
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={6}>
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1">
                  <strong>Time</strong>:
                </Typography>
                <Typography variant="body1">
                  {intakeDays.length > 0 &&
                    intakeDays.map((intakeDay, index) => (
                      <span key={index}>
                        {intakeDay.day}
                        {index < intakeDays.length - 1 && ', '}
                      </span>
                    ))}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenModal}
                  size="small"
                  style={{backgroundColor:buttonBackgroundColor}}
                >
                  Change
                </Button>
              </Box>

              <Typography variant="subtitle1">
                <strong>Current Module</strong>: {moduleDetailsMap[batches?.currentModule]}
              </Typography>

            
                <Typography variant="subtitle1" sx={{ flex: 1 }}>
                  <strong>Start Date</strong>: {start ? formatDate(start.startDate) : 'N/A'}
                </Typography>
                <Typography variant="subtitle1" sx={{ flex: 1 }}>
                  <strong>End Date</strong>: {end ? formatDate(end.endDate) : 'N/A'}
                </Typography>
             
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Dialog */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Change Session Details</Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Invoice />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="contained" color='error'>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Container;
